import { apiService } from './api';
import { LoginCredentials, AuthResponse, User, RegisterCredentials, RegistrationResponse } from '../types/auth';

export class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiService.post<AuthResponse>('/api/auth/login', credentials);
    return response.data;
  }

  async getProfile(): Promise<User> {
    const response = await apiService.get<User>('/api/auth/profile');
    return response.data;
  }

  async refreshToken(): Promise<{ token: string }> {
    const response = await apiService.post<{ token: string }>('/api/auth/refresh');
    return response.data;
  }

  async register(payload: RegisterCredentials): Promise<RegistrationResponse> {
    const response = await apiService.post<RegistrationResponse>('/api/auth/register', payload);
    return response.data;
  }

  async logout(): Promise<{ message: string }> {
    const response = await apiService.post<{ message: string }>('/api/auth/logout');
    return response.data;
  }

  async getSetupStatus(): Promise<{ hasSuperUser: boolean; requiresSetup: boolean }> {
    const response = await apiService.get<{ hasSuperUser: boolean; requiresSetup: boolean }>('/api/auth/setup-status');
    return response.data;
  }

  async createSuperUser(payload: {
    email: string;
    password: string;
    firstName?: string;
    lastName?: string;
  }): Promise<{ message: string; user: User }> {
    const response = await apiService.post<{ message: string; user: User }>('/api/auth/create-superuser', payload);
    return response.data;
  }

  async getDatabaseStatus(): Promise<{
    database: {
      ready: boolean;
      issues: string[];
      extensions: {
        allInstalled: boolean;
        missing: Array<{ name: string; description: string }>;
        installed: Array<{ name: string; description: string }>;
      };
    };
    superuser: {
      exists: boolean;
      requiresSetup: boolean;
    };
    overall: {
      ready: boolean;
      requiresSetup: boolean;
    };
  }> {
    const response = await apiService.get('/api/auth/database-status');
    return response.data;
  }
}

export const authService = new AuthService();
